import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import queryString from 'query-string';

export let apiController = new AbortController();

const resetApiController = () => {
  apiController.abort();
  apiController = new AbortController();
};

export const reportApi = createApi({
  reducerPath: 'reportApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_REPORT_PORT,
    prepareHeaders: (headers) => {
      headers.set('Accept', 'application/json');
      headers.set('X-API-KEY', process.env.REACT_APP_REPORT_API_KEY);
      headers.set('X-Auth-Token', `Bearer ${localStorage.getItem('token')}`); // Add API Key Here

      return headers;
    },
    paramsSerializer: (params) => {
      return queryString.stringify(params, {
        skipNull: true,
        skipEmptyString: true,
      });
    },
  }),
  endpoints: (builder) => ({
    fetchNewTransactionReport: builder.query({
      query: (params) => ({
        url: '/report',
        method: 'GET',
        params,
        signal: apiController.signal,
      }),
    }),
  }),
});

export const { useFetchNewTransactionReportQuery, useLazyFetchNewTransactionReportQuery } = reportApi;

export { resetApiController };
